import { createAsyncThunk } from '@reduxjs/toolkit';

import * as types from './types';
import { fetchCoursesLessonsFromApi } from './helpers';

export const getCoursesLessons = createAsyncThunk<any, any>(
  types.GET_COURSES_LESSONS,
  async (params: Record<string, any>, { getState }) => {
    return fetchCoursesLessonsFromApi(params, getState);
  },
);
